import { useQuery, type UseQueryOptions } from '@lumapps/base-api/react-query';
import { useSelector } from '@lumapps/redux/react';
import { isGoogleAccount } from '@lumapps/user/ducks/selectors';

import { type BatchGoogleDriveFilesRequestParam, getBatchGoogleDriveFilesApi, googleDriveQueryKeys } from '../../api';

/**
 * Hook to fetch a batch of Google Drive files.
 *
 * @param apiParams - Parameters for the API request.
 * @param queryOptions - Options for the useQuery hook.
 * @returns The result of the useQuery hook.
 */
export function useGetGoogleDriveFiles(apiParams?: BatchGoogleDriveFilesRequestParam, queryOptions?: UseQueryOptions) {
    const isGoogleUser = useSelector(isGoogleAccount);

    const params = { ...apiParams, isGoogleUser };

    return useQuery({
        queryKey: googleDriveQueryKeys['batch-files'](params),
        queryFn: async ({ signal }) => getBatchGoogleDriveFilesApi(params, signal),
        ...queryOptions,
    });
}
